import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';

type UtilityAccount = GetUtilityAccountQuery['plan']['utilityAccounts'][number];
interface Props {
  planId?: number;
}

// TODO - handle multiple utility accounts on a single plan
export const useUtilityAccount = ({ planId }: Props) => {
  const { data, loading, error } = useQuery<
    GetUtilityAccountQuery,
    GetUtilityAccountQueryVariables
  >(GET_UTILITY_ACCOUNT_QUERY, {
    skip: !planId,
    variables: { planId: planId || -1 },
  });

  let utilityAccount: UtilityAccount | undefined;
  if (data) {
    utilityAccount = data.plan?.utilityAccounts[0];
  }

  return { data: utilityAccount, error, loading };
};

export const GET_UTILITY_ACCOUNT_QUERY = gql`
  query GetUtilityAccount($planId: Int!) {
    plan(id: $planId) {
      id
      utilityAccounts {
        id
        billPayIneligibleWithLargeBalance
        pastDueAmount
        pastDueUpdatedAt
        utility {
          id
          displayName
          financialAssistanceProgramLink
          url
        }
      }
    }
  }
`;

export const utilityAccountMock = {
  withAch: {
    billPayIneligibleWithLargeBalance: false,
    id: 3,
    pastDueAmount: 123,
    pastDueUpdatedAt: '2021-01-01',

    utility: {
      displayName: 'Pepco',
      financialAssistanceProgramLink: 'https://fake.com',
      id: 10,
      url: 'www.pepco.com',
    },
  },
  withoutAch: {
    billPayIneligibleWithLargeBalance: false,
    id: 3,
    pastDueAmount: 123,
    pastDueUpdatedAt: '2021-01-01',
    utility: {
      displayName: 'Pepco',
      financialAssistanceProgramLink: 'https://fake.com',
      id: 10,
      url: 'www.pepco.com',
    },
  },
};

export const getUtilityAccountMock = {
  withAch: {
    plan: {
      id: 20,
      utilityAccounts: [utilityAccountMock.withAch],
    },
  },
  withoutAch: {
    plan: {
      id: 20,
      utilityAccounts: [utilityAccountMock.withoutAch],
    },
  },
};

export const useUtilityAccountMock = {
  data: utilityAccountMock.withAch,
  error: undefined,
  loading: false,
};
